var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    "data-inject-url": "https://edublink.html.devsblink.com/assets/images/animated-svg-icons/hybrid-distance-programs.svg",
    className: "svgInject",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.51448 30.4573C0.0954334 27.0383 0.0954334 21.4954 3.51448 18.0764L18.0764 3.51448C21.4954 0.0954334 27.0383 0.0954334 30.4573 3.51448C33.8764 6.93353 33.8764 12.4764 30.4573 15.8954L15.8954 30.4573C12.4764 33.8764 6.93353 33.8764 3.51448 30.4573Z",
    stroke: "#f8941f",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      strokeDasharray: "97, 99",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3715 39.0477C35.6109 39.0477 39.0477 35.6109 39.0477 31.3715C39.0477 27.1321 35.6109 23.6953 31.3715 23.6953C27.1321 23.6953 23.6953 27.1321 23.6953 31.3715C23.6953 35.6109 27.1321 39.0477 31.3715 39.0477Z",
    stroke: "#f8941f",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      strokeDasharray: "49, 51",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7905 10.791L23.1715 23.172",
    stroke: "#f8941f",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      strokeDasharray: "18, 20",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9619 36.781L36.781 25.9619",
    stroke: "#f8941f",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      strokeDasharray: "16, 18",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5337 9.57139L21.9527 7.15234",
    stroke: "#f8941f",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      strokeDasharray: "4, 6",
      strokeDashoffset: 0
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory4);
export default __webpack_public_path__ + "static/media/category-4.90e6914044e07065fd776282067387cc.svg";
export { ForwardRef as ReactComponent };